export default "__VITE_ASSET__BH7iT_0Q__"